var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExerciseReady(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0833 5.00008C14.9083 5.58341 12.3583 5.83341 10 5.83341C7.64167 5.83341 5.09167 5.58341 2.91667 5.00008L2.5 6.66675C4.05 7.08341 5.83333 7.35841 7.5 7.50008V18.3334H9.16667V13.3334H10.8333V18.3334H12.5V7.50008C14.1667 7.35841 15.95 7.08341 17.5 6.66675L17.0833 5.00008ZM10 5.00008C10.9167 5.00008 11.6667 4.25008 11.6667 3.33341C11.6667 2.41675 10.9167 1.66675 10 1.66675C9.08333 1.66675 8.33333 2.41675 8.33333 3.33341C8.33333 4.25008 9.08333 5.00008 10 5.00008Z",
    fill: "#2F54EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExerciseReady);
export default __webpack_public_path__ + "static/media/icon_exercise_ready.44ddc4da8e022c2e39df8e8fd4859325.svg";
export { ForwardRef as ReactComponent };